module.exports = __webpack_public_path__ + "static/img/btn4.f54bd1bf.png";